import { AspectRatio, Badge, Box, Card, DataList, Flex, Heading, Inset } from '@radix-ui/themes'

import HeicSafeImage from './HeicSafeImage'

import { formatCurrency, formatWithThousandSep } from '@/utils/utils'
import { VehicleBasePic } from '@/interfaces/Vehicle'
import { makeUrlImage } from '@/hooks/connectionData'

const VehicleCard: React.FC<{ vehicle: VehicleBasePic | null }> = ({ vehicle }) => {
  const odometer_format = formatWithThousandSep(vehicle?.odometer ?? 0)
  const price_format = formatCurrency(vehicle?.price ?? 0)
  const appraisal_format = formatCurrency(vehicle?.appraisal ?? 0)

  return (
    <Card>
      {vehicle ? (
        <Flex gap="4">
          <Inset side="left" style={{ minWidth: '12rem' }}>
            <AspectRatio
              ratio={1}
              style={{
                backgroundColor: 'var(--gray-6)',
                overflow: 'hidden',
              }}
            >
              <HeicSafeImage
                src={makeUrlImage(vehicle?.pictures?.public?.[0] || '')}
                alt="Vehículo"
                style={{
                  objectFit: 'cover',
                  height: '100%',
                  width: '100%',
                }}
              />
            </AspectRatio>
          </Inset>
          <Flex direction="column" gap="4">
            <Box>
              <Heading size="2">
                {vehicle.brand} {vehicle.model} {vehicle.year}
              </Heading>
              <Badge variant="outline" color="gray">
                {vehicle.plate}
              </Badge>
            </Box>

            <DataList.Root size="1">
              <DataList.Item>
                <DataList.Label>Kilometraje</DataList.Label>
                <DataList.Value>{odometer_format}</DataList.Value>
              </DataList.Item>
              <DataList.Item>
                <DataList.Label>Precio publicado</DataList.Label>
                <DataList.Value>{price_format}</DataList.Value>
              </DataList.Item>
              <DataList.Item>
                <DataList.Label>Tasación</DataList.Label>
                <DataList.Value>{appraisal_format}</DataList.Value>
              </DataList.Item>
            </DataList.Root>
          </Flex>
        </Flex>
      ) : (
        <>
          <div className="text-6xl">🚗</div>
          <span className="mt-2 text-sm font-medium">Seleccionar Vehículo</span>
        </>
      )}
    </Card>
  )
}
export default VehicleCard
